import type { CentrifugeMessage } from '../messageTypes';

export interface LayoutChatMessageUnparsed {
  data: {
    type: 'LayoutChat';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export const isLayoutChatMessageUnparsed = (item: CentrifugeMessage): item is LayoutChatMessageUnparsed => {
  return 'data' in item && item.data.type === 'LayoutChat' && typeof item.data.message === 'string';
};

export interface LayoutChatMessage {
  data: {
    type: 'LayoutChat';
    message: {
      message: string;
      messageHTML: string;
      messageJa?: string;
      messageHTMLJa?: string;
      opt: {
        layout: {
          black: {
            fontColor: string;
            header: {
              img: string;
              width: number;
              height: number;
            } | null;
            middle: {
              img: string;
              width: number;
              height: number;
            } | null;
            footer: {
              img: string;
              width: number;
              height: number;
            } | null;
          };
          white: {
            fontColor: string;
            header: {
              img: string;
              width: number;
              height: number;
            } | null;
            middle: {
              img: string;
              width: number;
              height: number;
            } | null;
            footer: {
              img: string;
              width: number;
              height: number;
            } | null;
          };
        };
      };
    };
    created_at?: number;
  };
  offset: number;
}

export const isLayoutChatMessage = (item: CentrifugeMessage): item is LayoutChatMessage => {
  return 'data' in item && item.data.type === 'LayoutChat' && typeof item.data.message !== 'string';
};

export interface EventAnimCoinMessageUnparsed {
  data: {
    type: 'EventAnimCoin';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export const isEventAnimCoinMessageUnparsed = (item: CentrifugeMessage): item is EventAnimCoinMessageUnparsed => {
  return 'data' in item && item.data.type === 'EventAnimCoin' && typeof item.data.message === 'string';
};

export interface EventAnimCoinMessage {
  data: {
    type: 'EventAnimCoin';
    message: {
      message: string;
      messageHTML: string;
      messageJa?: string;
      messageHTMLJa?: string;
      opt: {
        layout: {
          black: {
            fontColor: string;
            header: {
              img: string;
              width: number;
              height: number;
            } | null;
            middle: {
              img: string;
              width: number;
              height: number;
            } | null;
            footer: {
              img: string;
              width: number;
              height: number;
            } | null;
          };
          white: {
            fontColor: string;
            header: {
              img: string;
              width: number;
              height: number;
            } | null;
            middle: {
              img: string;
              width: number;
              height: number;
            } | null;
            footer: {
              img: string;
              width: number;
              height: number;
            } | null;
          };
        };
        contents: {
          image: string;
          json: string;
          width: number;
          height: number;
        } | null;
      };
    };
    created_at?: number;
  };
  offset: number;
}

export const isEventAnimCoinMessage = (item: CentrifugeMessage): item is EventAnimCoinMessage => {
  return 'data' in item && item.data.type === 'EventAnimCoin' && typeof item.data.message !== 'string';
};

export interface EventRankMessageUnparsed {
  data: {
    type: 'EventRank';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export const isEventRankMessageUnparsed = (item: CentrifugeMessage): item is EventRankMessageUnparsed => {
  return 'data' in item && item.data.type === 'EventRank';
};

export interface EventRankMessage {
  data: {
    type: 'EventRank';
    message: { rank: number; score: number; endDateTime: string };
    created_at?: number;
  };
  offset: number;
}

export const isEventRankMessage = (item: CentrifugeMessage): item is EventRankMessage => {
  return 'data' in item && item.data.type === 'EventRank' && typeof item.data.message !== 'string';
};
